import { defineStore } from "pinia";
import axios, { AxiosResponse } from 'axios';
import { QueueItem, QueueQueryResult } from "@/types";
import { BFilter, BFilterableField } from "@/components/BFilterEditor/BFilterEditor.types";
import { BSortOptions, BTableOptions, serializeSortBy } from "@/components/BTable/BTable.types";
import { serializeFilters } from "@/components/BTable/HelperFunctions";

export const useQueueStore = defineStore('queueStore', () => {
    const apiUrl = "api/v1/queue";

    function getQueueStatus() {
        return axios.get(`${apiUrl}/status`, { params: {} });
    }

    function getQueueItems(tableOptions: BTableOptions, filterInfo: BFilter[], filterableFields: BFilterableField[], sortingInfo: BSortOptions[]): Promise<AxiosResponse<QueueQueryResult>> {

        let filterText = serializeFilters(filterInfo, filterableFields);
        let sortText = serializeSortBy(sortingInfo);

        return axios.get(`${apiUrl}`, { params: { page: tableOptions.page, pageSize: tableOptions.itemsPerPage, filter: filterText, sort: sortText, pagingMode: tableOptions.pagingMode } });
    }

    function changeQueueStatus(pauseQueue: boolean) {
        return axios.post(`${apiUrl}/set-paused`, { paused: pauseQueue })
    }

    return { getQueueStatus, getQueueItems, changeQueueStatus }
})